import React from 'react';
import ActivityLoader from './ActivityLoader';

const AlertNotification = ({message, iconClass, loader, type='info'}) => {
    return (
        <div className={`mbg-3 alert alert-${type} alert-dismissible fade show`} role="alert">
            <span className="pr-2">
            <i className={iconClass || ''}></i>
            </span>
            {message}
            <span className='ml-2'>{loader && <ActivityLoader inline={true} width={15}/>}</span>
        </div>
    );
};

export default AlertNotification;